document.addEventListener('DOMContentLoaded', function () {
  if (window.fhInitDone) return;
  window.fhInitDone = true;
  initReveals();
  initCountUp();
  initGaleriaProducto();
  initSelectorVariantes();
  initFaq();
  initAcordeon();
});

function initAcordeon() {
  var items = document.querySelectorAll('[data-fh-acc-item]');
  items.forEach(function (item) {
    var head = item.querySelector('[data-fh-acc-head]');
    if (!head) return;
    head.addEventListener('click', function () {
      item.classList.toggle('fh-abierta');
    });
  });
}

function initReveals() {
  var els = document.querySelectorAll('.fh-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('fh-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fh-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-fh-countup]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-fh-countup'));
      var suffix = el.getAttribute('data-fh-suffix') || '';
      if (reduce) { el.textContent = target + suffix; observer.unobserve(el); return; }
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var root = document.querySelector('[data-fh-galeria]');
  if (!root) return;
  var main = root.querySelector('[data-fh-galeria-principal]');
  var thumbs = root.querySelectorAll('[data-fh-galeria-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      main.src = src;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('fh-thumb-activa'); });
      thumb.classList.add('fh-thumb-activa');
    });
  });
}

function initSelectorVariantes() {
  var root = document.querySelector('[data-fh-producto]');
  if (!root) return;
  var dataEl = root.querySelector('[data-fh-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = root.querySelectorAll('[data-fh-opcion]');
  var idInput = root.querySelector('[data-fh-variant-id]');
  var precioEl = root.querySelector('[data-fh-precio]');
  var precioCompareEl = root.querySelector('[data-fh-precio-compare]');
  var btn = root.querySelector('[data-fh-add-btn]');
  var btnTextoDisponible = btn ? btn.getAttribute('data-texto-disponible') : '';
  var btnTextoAgotado = btn ? btn.getAttribute('data-texto-agotado') : '';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function actualizar() {
    if (!selects.length) return;
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (precioEl) precioEl.textContent = formatMoney(match.price);
    if (precioCompareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioCompareEl.textContent = formatMoney(match.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? btnTextoDisponible : btnTextoAgotado;
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function initFaq() {
  var items = document.querySelectorAll('[data-fh-faq-item]');
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-fh-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('fh-faq-abierta');
      items.forEach(function (i) { i.classList.remove('fh-faq-abierta'); });
      if (!abierto) item.classList.add('fh-faq-abierta');
    });
  });
}
